import React, { useState, useEffect } from "react";

import {
    EmptyListPage,
    TableLoader,
} from "../../../commons";
import { formatDate } from "../../../../utils/commonFunctions";
import { EmptyAssignedUser, EmptyPage } from "../../../../assets/images";


type AppProps = {
    userFetching: boolean | undefined;
    authSuccess?: number | null;
    singleClientDirectory: any;
};
const SubscriptionTab = ({
    userFetching,
    authSuccess,
    singleClientDirectory
}: AppProps) => {

    let isData = singleClientDirectory?.client_signup_details?.subscription_plan || singleClientDirectory?.client_signup_details?.payment_amount || singleClientDirectory?.client_signup_details?.payment_date || singleClientDirectory?.client_signup_details?.order_id

    return (

        <div
            style={{
                backgroundColor: "white",
                paddingTop: "23px",
                border: "1px solid #bfcbe1",
                borderRadius: "0px 0px 6px 6px",
            }}
        >
            {isData ? <>
                <div className="row">
                    <div className="col-md-12 d-flex justify-content-between">
                        <div className="col-md-4 ml-3" style={{ padding: 0 }}>
                            <div
                                className="d-flex flex-column"
                                style={{ justifyContent: "center", alignItems: "flex-start" }}
                            >
                                <h6 style={{ fontSize: "18px", fontWeight: 500 }}>
                                    Subscription Details
                                </h6>
                                <div
                                    style={{
                                        color: "rgb(124, 141, 176)",
                                        fontSize: "13px",
                                        fontWeight: 500,
                                    }}
                                >
                                    View all the subscription details
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="row p-4">

                    {singleClientDirectory?.client_signup_details?.subscription_plan ? <div className="col-md-3">
                        <label htmlFor="lastName">Subscription Plan</label>
                        <div >
                            <input
                                type="text"
                                className="form-control"
                                name="lastName"
                                value={singleClientDirectory?.client_signup_details?.subscription_plan === "basic_plan" ? "Basic Plan" : "Advanced Plan"}
                                disabled={true}
                            />
                        </div>
                    </div> : null}


                    {singleClientDirectory?.client_signup_details?.payment_amount ? <div className="col-md-3">
                        <label htmlFor="lastName">Payment Amount</label>
                        <div >
                            <input
                                type="text"
                                className="form-control"
                                name="lastName"
                                value={singleClientDirectory?.client_signup_details?.payment_amount ? (+singleClientDirectory?.client_signup_details?.payment_amount / 100) : ""}
                                disabled={true}
                            />
                        </div>
                    </div> : null}


                    {singleClientDirectory?.client_signup_details?.payment_date ? <div className="col-md-3">
                        <label htmlFor="lastName">Payment Date</label>
                        <div >
                            <input
                                type="text"
                                className="form-control"
                                name="lastName"
                                value={singleClientDirectory?.client_signup_details?.payment_date ? formatDate(singleClientDirectory?.client_signup_details?.payment_date) : ""}
                                disabled={true}
                            />
                        </div>
                    </div> : null}



                    {singleClientDirectory?.client_signup_details?.order_id ? <div className="col-md-3">
                        <label htmlFor="lastName">Order Id</label>
                        <div >
                            <input
                                type="text"
                                className="form-control"
                                name="lastName"
                                value={singleClientDirectory?.client_signup_details?.order_id ? singleClientDirectory?.client_signup_details?.order_id : ""}
                                disabled={true}
                            />
                        </div>
                    </div> : null}
                </div>
            </>
                :
                <div className="mt-5 p-4">
                    <EmptyListPage
                        title="No Data Found !"
                        imageWidth="25%"
                        image={EmptyAssignedUser}
                    />
                </div>}



        </div>

    );
};

export default SubscriptionTab;
